export default __webpack_public_path__ + "static/media/den.1160006a.svg";